// *********************************************************************************************************************
// Custom JavaScript
// *********************************************************************************************************************

// =====================================================================================================================
// Splide
// =====================================================================================================================
import Splide from '@splidejs/splide'

const imageSliders = document.querySelectorAll('#image-slider');
if (imageSliders) {
    imageSliders.forEach((slider) => {
        new Splide(slider, {
            type: 'loop',
            perPage: 2,
            arrows: false,
            pagination: false,
            gap: '3rem',
            padding: '5rem',
            autoplay: true,
            breakpoints: {
                720: {
                    perPage: 2,
                    gap: '1rem',
                    padding: '0rem'
                },
                576: {
                    perPage: 1
                },
            }
        }).mount();
    });
}



// =====================================================================================================================
// Breakpoint Manager
// =====================================================================================================================
import BreakpointManager from './breakpoint-manager'

// Custom Breakpoints object
const breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1460,
}

// Instantiate the Breakpoint Manager
const breakpointManager = new BreakpointManager(breakpoints, true);



// =====================================================================================================================
// Forms
// =====================================================================================================================

const registrationForm = document.getElementById('gform_2');
if (registrationForm) {

    function getPricing() {
        // Map Inputs
        const inputRegistrationTypeSummer    = document.querySelector('.registration-type input[value="Summer"]');
        const inputRegistrationTypeSchool    = document.querySelector('.registration-type input[value="School Year"]');
        const inputIsClubMember              = document.querySelector('.is-club-member input');
        const inputNumOfChildren             = document.querySelector('.number-of-children input');
        const inputNonmemberNumOfChildren    = document.querySelector('.nonmember-number-of-children input');
        const inputNonmemberChildrenUnder6   = document.querySelector('.children-under-six input');
        const inputNonmemberChildrenMilitary = document.querySelector('.children-military input');
        const inputNonmemberSummerClub       = document.querySelector('.nonmember-summer-club input');
        const inputProgramSummerMorningClub  = document.querySelector('.summer-programs input[value="Morning Club"]');
        const inputProgramSummerSchool       = document.querySelector('.summer-programs input[value="Summer School Morning Club"]');
        const inputProgramExtendedSummer     = document.querySelector('.summer-programs input[value="Extended Summer Program"]');
        const inputOnlinePayment             = document.querySelector('.payment-method input[value="Online Payment"]');
        const inputTotal                     = document.querySelector('.total-due input');


        // Variables
        let registrationMode = inputRegistrationTypeSummer.checked ? 'summer' : 'school'
        let isClubMember = inputIsClubMember.checked;
        let numberOfChildren = Number(inputNumOfChildren.value);
        let programSummerMorningClub = inputProgramSummerMorningClub.checked;
        let programSummerSchool = inputProgramSummerSchool.checked;
        let programExtendedSummer = inputProgramExtendedSummer.checked;
        let nonmemberNumOfChildren = Number(inputNonmemberNumOfChildren.value);
        let nonmemberChildrenUnder6 = Number(inputNonmemberChildrenUnder6.value) ?? 0;
        let nonmemberChildrenMilitary = Number(inputNonmemberChildrenMilitary.value) ?? 0;
        let nonmemberSummerClub = inputNonmemberSummerClub.checked;
        let onlinePayment = inputOnlinePayment.checked;


        // Pricing
        const pricePerClubMember = registrationMode === 'summer' ? 50 : 100;
        const pricePerNonmember = 100;
        const priceMembershipMax = 225;
        let total = 0;



        // Calculate price per Child
        // -------------------------------------------------------------------------------------------------------------

        if (registrationMode === 'school'){
            numberOfChildren = Number(inputNumOfChildren.value);
            total = numberOfChildren * pricePerClubMember > priceMembershipMax ? priceMembershipMax : numberOfChildren * pricePerClubMember;
        }
        // Summer Program
        else {
            // Members
            if (isClubMember){
                numberOfChildren = Number(inputNumOfChildren.value);
                total = numberOfChildren * pricePerClubMember;
            }

            // Nonmembers
            else {
                // Update Values
                nonmemberNumOfChildren = Number(inputNonmemberNumOfChildren.value);
                nonmemberChildrenUnder6 = Number(inputNonmemberChildrenUnder6.value) ?? 0;
                nonmemberChildrenMilitary = Number(inputNonmemberChildrenMilitary.value) ?? 0;
                nonmemberSummerClub = inputNonmemberSummerClub.checked;

                // Set total Number of Children for Program options
                numberOfChildren = nonmemberNumOfChildren;

                // Calculate Number of Children that need to be paid for
                let payableNumOfChildren = Math.max((nonmemberNumOfChildren - nonmemberChildrenUnder6 - nonmemberChildrenMilitary), 0)

                // Set the new base total
                total = (payableNumOfChildren * pricePerNonmember) > priceMembershipMax ? priceMembershipMax : payableNumOfChildren * pricePerNonmember;

                if (nonmemberSummerClub) {
                    total += numberOfChildren * 50;
                }
            }
        }



        // Program Options
        if (programSummerMorningClub) {
            let tempTotal = 0;
            tempTotal = numberOfChildren * 200;
            total += tempTotal > 450 ? 450 : tempTotal;
        }
        if (programSummerSchool) {
            total += numberOfChildren * 125;
        }
        if (programExtendedSummer) {
            total += numberOfChildren * 50;
        }

        // Online Payment Fee
        if (onlinePayment) {
            total += total * 0.04;
        }


        // Log
        console.log('Registration Mode: ' + registrationMode);
        console.log('Number of Children: ', numberOfChildren);
        console.log('Is Club Member: ', isClubMember);
        console.log('Total: ', total);


        // Update Total in Form
        updateFieldAndRecalculate(inputTotal, total);
    }

    // Run the Pricing Function
    getPricing();


    // Run the Pricing function on form change
    registrationForm.addEventListener('change', function() {
        getPricing();
    });

}

// Function for updating a field a dispatching an event so Gravity Forms knows to update
function updateFieldAndRecalculate(field, value) {
    // Update Field
    field.value = value;

    // Trigger a change event on the field to signal Gravity Forms to recalculate
    let event = new Event('change');
    field.dispatchEvent(event);
}